import { useFeatureFlag } from 'featureFlags/hooks';
import { Show } from 'shared';

type RenderIfFFEnabledProps = {
  featureFlag: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export const RenderIfFFEnabled = ({
  featureFlag,
  children,
  fallback = null,
}: RenderIfFFEnabledProps) => {
  const isFeatureEnabled = useFeatureFlag(featureFlag);

  return (
    <Show when={isFeatureEnabled} fallback={fallback}>
      {children}
    </Show>
  );
};
